
import Close from 'assets/image/icons/buttons/close.svg'
import clsx from 'clsx'
import { useId } from 'react'
import { contextActions } from 'shared/styles'

import {
	$search,
	$searchDraft,
} from '../../hooks/useFilters'
import css from './FilterForm.module.scss'

const resetSearch = () => {
	$search.set('')
	$searchDraft.set('')
}

export function SearchForm() {
	const id = useId()

	return (
		<form
			className={css.root}
			onReset={resetSearch as () => void}
			onSubmit={event => {
				event.preventDefault()
				const form = event.currentTarget
				const input = form.search

				if (input instanceof HTMLInputElement) {
					$search.set(input.value)
				}
			}}
		>
			<div className={css.fieldWrapper}>
				<input
					autoComplete='off'
					className={css.field}
					name='search'
					onBlur={event => {
						const search = event.currentTarget.value
						$search.set(search)
					}}
					onChange={event => {
						$searchDraft.set(event.currentTarget.value)
					}}
					placeholder='Search'
					type='text'
				/>
				<button className={css.reset} type='reset'>
					<img alt='close' src={Close} />
				</button>
			</div>
			<div
				className={clsx(css.filters, contextActions.menu)}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
			>
			</div>
		</form>
	)
}
